const sampleBand = (
  histogram,
  nObservations,
  lowPercentage,
  highPercentage
) => {
  const [lowThreshold, highThreshold] = [
    Math.floor(lowPercentage * nObservations),
    Math.ceil(highPercentage * nObservations),
  ];
  let [low, high] = [0, 0];
  let [lowCounter, highCounter] = [0, 0];

  for (
    let r = 2, rr = histogram.length;
    (low === 0 || high === 0) && r < rr;
    r++
  ) {
    lowCounter += histogram[r];
    highCounter += histogram[rr - (r + 1)];

    if (low === 0 && lowCounter >= lowThreshold) {
      low = r;
    }

    if (high === 0 && highCounter >= highThreshold) {
      high = rr - (r + 1);
    }
  }

  return [low, high];
};

const stdDeviation = histogram => {
  let total = 0;
  let count = 0;

  const len = histogram.length;

  let low = 0;
  let high = 0;

  for (let i = 0; i < len; i++) {
    total += histogram[i] * i;
    count += histogram[i];

    if (histogram[i] > 0) {
      if (low === 0) {
        low = i;
      }
      high = i;
    }
  }

  const mean = total / count;

  total = 0;
  for (let i = 0; i < len; i++) {
    const v = i - mean;
    total += v * v * histogram[i];
  }
  const meansq = total / count;

  return {
    mean,
    deviation: Math.sqrt(meansq),
    low,
    high,
  };
};

export class Statistics {
  constructor(options = {}) {
    this.depth = options.depth ?? 65535;
    this.bandCount = options.bandCount ?? 5;
    this._init();
  }

  _init() {
    this.counts = [];
    for (let c = 0; c < this.bandCount; c++) {
      this.counts.push(new Uint16Array(this.depth));
    }
    this.observations = 0;
  }

  reset() {
    this._init();
  }

  add(tile) {
    const data = tile.getData();
    const alphaBandIndex = this.bandCount - 1;

    for (let i = 0, ii = data.length; i < ii; i += this.bandCount) {
      // the last band should be the alpha band.
      if (data[i + alphaBandIndex] > 0) {
        for (let c = 0; c < alphaBandIndex; c++) {
          this.counts[c][data[i + c]] += 1;
          this.observations += 1;
        }
      }
    }
  }

  sample(lowPercentage, highPercentage) {
    const bandSamples = [];
    for (let b = 0, bb = this.bandCount; b < bb; b++) {
      bandSamples.push(
        sampleBand(
          this.counts[b],
          this.observations,
          lowPercentage,
          highPercentage
        )
      );
    }
    return bandSamples;
  }

  standardDeviation(n) {
    const bandValues = [];
    for (let b = 0, bb = this.bandCount; b < bb; b++) {
      const st = stdDeviation(this.counts[b]);
      bandValues.push([st.mean - st.deviation * n, st.mean + st.deviation * n]);
    }
    return bandValues;
  }
}
